import styles from './wishlist-alert.scss';
import {css, CSSResult, html, LitElement, nothing, unsafeCSS} from 'lit';
import {customElement, property} from 'lit/decorators.js';
import typographyStyles from '../../../styles/responsive-nui-typography.scss';
import {CookieHandlerInstance} from '../../../scripts/service/cookiehandler.js';
import {consume} from '@lit/context';
import {i18nContext} from '../../../scripts/context/i18nContext.js';
import {Messages} from '../../../@types/wishlist.js';
import close from '@breuni-ui/bdk/dist/design-tokens/images/icons/o-ic-16_close.svg';
import {hideIconFromAssistiveTechnology} from '../icon/icon-accessibility.js';

@customElement('wishlist-alert')
export class WishlistAlert extends LitElement {

  @consume({context: i18nContext})
  @property({attribute: false})
  private messages!: Messages;

  @property({type: String, attribute: 'cookie-id'}) private cookieId: string | undefined = undefined;
  @property({type: String, attribute: 'local-storage-id'}) private localStorageId: string | undefined = undefined;
  @property({type: String, attribute: 'button-aria-label'}) private buttonAriaLabel: string | undefined = undefined;

  private shouldDisplayContent = true;

  connectedCallback() {
    super.connectedCallback();
    this.evaluateLocalStorageValue();
    this.evaluateCookieValue();
  }

  private evaluateLocalStorageValue() {
    if (!this.localStorageId) return;

    const value = window.localStorage.getItem(this.localStorageId);
    this.shouldDisplayContent = value !== 'dismissed';
  }

  private evaluateCookieValue() {
    if (!this.cookieId) return;

    const cookieVal = CookieHandlerInstance.getCookie(this.cookieId);
    if (cookieVal !== undefined && cookieVal !== '') {
      this.shouldDisplayContent = false;
      this.setCookieValue(); // reset timer
    }
  }

  private handleClose() {
    this.setLocalStorageValue();
    this.setCookieValue();
    this.hide();
  }

  private setLocalStorageValue() {
    if (!this.localStorageId) return;
    window.localStorage.setItem(this.localStorageId, 'dismissed');
  }

  private setCookieValue() {
    if (!this.cookieId) return;
    CookieHandlerInstance.setCookie(this.cookieId, 'dismissed', 30);
  }

  private hide() {
    this.shouldDisplayContent = false;
    this.requestUpdate();
  }

  static get styles(): CSSResult[] {
    return [css`${unsafeCSS(styles)}`, css`${unsafeCSS(typographyStyles)}`];
  }

  protected render() {
    if (!this.shouldDisplayContent) return nothing;

    return html`
      <div id="${this.cookieId ?? this.localStorageId ?? ''}" class="wishlist-alert-wrapper bdk-alert" variant="neutral-light"
           closable="">
        <div>
          <slot name="title"></slot>
          <slot></slot>
        </div>
        <button class="bdk-button-icon" size="extra-extra-small" variant="overlay-light"
                aria-label="${this.buttonAriaLabel ?? this.messages['ents.wishlist.actionmenu.close']}"
                type="button"
                @click="${this.handleClose}">
          ${hideIconFromAssistiveTechnology(close())}
        </button>
      </div>
    `;
  }
}
